var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mentor (Messages)",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-1153 -270)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component 15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 19"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-33 -197H287V120H-33V-197Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-33 120H-34V121H-33V120ZM287 119H-33V121H287V119ZM-32 120V-197H-34V120H-32Z",
    fill: "#E0E0E0",
    mask: "url(#path-1-inside-1_0_1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 163168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 163165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 162844"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 12,
    cy: 12,
    r: 20,
    fill: "white",
    stroke: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vscode-icons:file-type-excel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6865 11.5123L6.38477 10.0498V20.8566C6.38486 20.974 6.40809 21.0902 6.4531 21.1986C6.49812 21.307 6.56406 21.4055 6.64714 21.4885C6.73023 21.5714 6.82884 21.6372 6.93734 21.682C7.04584 21.7269 7.16211 21.7499 7.27952 21.7498H21.6045C21.722 21.7501 21.8385 21.7272 21.9472 21.6825C22.0558 21.6377 22.1546 21.572 22.2379 21.489C22.3211 21.4061 22.3872 21.3075 22.4323 21.199C22.4774 21.0904 22.5007 20.9741 22.5008 20.8566V16.8748L14.6865 11.5123Z",
    fill: "#185C37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.6865 2.25H7.27952C7.16211 2.2499 7.04584 2.27293 6.93734 2.31776C6.82884 2.3626 6.73023 2.42837 6.64714 2.51132C6.56406 2.59426 6.49812 2.69276 6.4531 2.80119C6.40809 2.90962 6.38486 3.02585 6.38477 3.14325V7.125L14.6865 12L19.0823 13.4625L22.5008 12V7.125L14.6865 2.25Z",
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.38477 7.125H14.6865V12H6.38477V7.125Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.1,
    d: "M12.3263 6.1499H6.38477V18.3374H12.3263C12.563 18.3362 12.7898 18.2418 12.9574 18.0746C13.125 17.9074 13.22 17.6809 13.2218 17.4442V7.04315C13.22 6.80641 13.125 6.57989 12.9574 6.4127C12.7898 6.2455 12.563 6.15108 12.3263 6.1499Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.2,
    d: "M11.838 6.6377H6.38477V18.8252H11.838C12.0748 18.824 12.3015 18.7296 12.4691 18.5624C12.6368 18.3952 12.7317 18.1687 12.7335 17.9319V7.53095C12.7317 7.2942 12.6368 7.06769 12.4691 6.90049C12.3015 6.73329 12.0748 6.63887 11.838 6.6377Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.2,
    d: "M11.838 6.6377H6.38477V17.8502H11.838C12.0748 17.849 12.3015 17.7546 12.4691 17.5874C12.6368 17.4202 12.7317 17.1937 12.7335 16.9569V7.53095C12.7317 7.2942 12.6368 7.06769 12.4691 6.90049C12.3015 6.73329 12.0748 6.63887 11.838 6.6377Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.2,
    d: "M11.3498 6.6377H6.38477V17.8502H11.3498C11.5865 17.849 11.8133 17.7546 11.9809 17.5874C12.1485 17.4202 12.2435 17.1937 12.2453 16.9569V7.53095C12.2435 7.2942 12.1485 7.06769 11.9809 6.90049C11.8133 6.73329 11.5865 6.63887 11.3498 6.6377Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M2.3955 6.6377H11.349C11.5862 6.6375 11.8137 6.73147 11.9816 6.89897C12.1496 7.06646 12.2441 7.29377 12.2445 7.53095V16.4694C12.2441 16.7066 12.1496 16.9339 11.9816 17.1014C11.8137 17.2689 11.5862 17.3629 11.349 17.3627H2.3955C2.27804 17.3629 2.16168 17.3399 2.05309 17.2951C1.9445 17.2504 1.84581 17.1846 1.76264 17.1016C1.67948 17.0187 1.61348 16.9202 1.56841 16.8117C1.52334 16.7032 1.5001 16.5869 1.5 16.4694V7.53095C1.5001 7.41348 1.52334 7.29719 1.56841 7.18871C1.61348 7.08023 1.67948 6.9817 1.76264 6.89875C1.84581 6.81579 1.9445 6.75004 2.05309 6.70525C2.16168 6.66045 2.27804 6.6375 2.3955 6.6377Z",
    fill: "url(#paint0_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M4.27539 14.9047L6.15864 11.9917L4.43364 9.09521H5.81889L6.76014 10.95C6.84714 11.1255 6.91014 11.256 6.93864 11.343H6.95139C7.01289 11.202 7.07814 11.0662 7.14639 10.9335L8.15289 9.09821H9.42789L7.65864 11.9782L9.47289 14.907H8.11614L7.02864 12.8737C6.97815 12.7863 6.93524 12.6947 6.90039 12.6H6.88239C6.85068 12.6923 6.8084 12.7806 6.75639 12.8632L5.63664 14.9047H4.27539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M21.6043 2.25H14.6855V7.125H22.4998V3.14325C22.4997 3.02579 22.4765 2.90949 22.4314 2.80102C22.3863 2.69254 22.3203 2.59401 22.2372 2.51105C22.154 2.4281 22.0553 2.36234 21.9467 2.31755C21.8381 2.27276 21.7218 2.2498 21.6043 2.25Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M14.6855 12H22.4998V16.875H14.6855V12Z",
    fill: "#107C41"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 3.3705,
    y1: 5.9357,
    x2: 10.374,
    y2: 18.0647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white",
    transform: "translate(-1153 -270)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.7fa44d465ab16e55e77219046112e47c.svg";
export { ForwardRef as ReactComponent };